export default "__VITE_ASSET__lBcHe1DE__"